import { useEffect } from 'react';

function useScroll (callback, dependencies) {
    useEffect(() => {
        const handleScroll = () => {
            const scroll = window.pageYOffset;
            callback(scroll);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, dependencies);
}

export default useScroll;
